var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.css(),
    ( _obj = {}, _obj[_vm.css('', 'floating')] = _vm.floating, _obj[_vm.css('', 'inline')] = _vm.inline, _obj ) ]},[_c('span',{class:_vm.css('icon'),style:(("width: " + _vm.size + "px; height: " + _vm.size + "px")),attrs:{"data-test":"icon"}},[_c('LoadingSvg')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }